<template>
  <v-dialog v-model="showDialog" scrollable width="650px">
    <v-card>
      <v-card-title>Información del Usuario UNI</v-card-title>
      <v-card-text style="height: 600px">
        <div v-if="fetching" class="d-flex justify-center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <div v-else>
          <DetalleAlumno :modal="true" :userData="getSelectedAlumnoInfo" />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  components: {
    DetalleAlumno: () =>
      import('@/components/company/common/DetallePostulante.vue')
  },
  data() {
    return {
      alumnoData: {}
    }
  },

  methods: {
    ...mapMutations('admin', ['setShowAlumnoInfoDialog'])
  },

  computed: {
    showDialog: {
      get() {
        return this.getShowAlumnoInfoDialog
      },
      set(value) {
        this.setShowAlumnoInfoDialog(value)
      }
    },
    ...mapGetters('admin', [
      'getShowAlumnoInfoDialog',
      'getSelectedAlumnoInfo'
    ]),
    ...mapGetters('user', ['fetching'])
  }
}
</script>

<style>
</style>
